// extracted by mini-css-extract-plugin
export default {"person":"Person_person__MF+fR","person-name":"Person_person-name__XSuST","person-role":"Person_person-role__BBCis","person-image":"Person_person-image__zEZPO"};